export interface UpdateUserData {
  givenName?: string;
  familyName?: string;
  companyName?: string;
  secondaryEmail?: string;
  phoneNumber?: string;
  messagePreference?: string;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface UpdatePasswordData {
  currentPassword: string;
  newPassword: string;
}

export class UserService {
  static async saveMessageOptIn(optInData: { optedIn: boolean }): Promise<any> {
    const response = await fetch("/api/user/message-optin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(optInData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to save message opt-in");
    }

    return response.json();
  }

  static async getUserProfile(): Promise<any> {
    const response = await fetch("/api/user/profile", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch user profile");
    }

    return response.json();
  }

  static async updateUserProfile(userData: UpdateUserData): Promise<any> {
    const response = await fetch("/api/user/profile", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update user profile");
    }

    return response.json();
  }

  static async updatePassword(passwordData: UpdatePasswordData): Promise<{ message: string }> {
    const response = await fetch("/api/user/profile/password", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(passwordData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to update password");
    }

    return response.json();
  }
}